// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // default
  // c: "mi3xkNpDMBw=",
  // k: "OLCZ5OHN91o=",
  // c: "EMzt6h8TXkY=",
  // k: "9d9DiTkBwpbbC2ZMUmlHTQ==",

  // c: "cYk7f0UoQJs=",
  // k: " lbRROygoHF7deBnOb5BUYw==",

  //cpscm
  // c: "cYk7f0UoQJs=",
  // k: "lbRROygoHF7deBnOb5BUYw==",


  //mcpsc
  //  c: "EMzt6h8TXkY=",
  //  k: "9d9DiTkBwpbbC2ZMUmlHTQ==",


  //kgmsc
  //  c: 'ZpHxWf0fnSI=',
  //  k: 'RwUIU72RoJ7bC2ZMUmlHTQ=='
  //kmsc
  c: "XSHeHMdGf1E=",
  k: "qbv27zCIel/deBnOb5BUYw==",

  //fbic
  // c: '1QI8gPf3wHw=',
  // k: 'a3lWnOYyx/jVS5X9E7CmNQ=='


};
